/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_UnexpectedInputs */

const en_error_unexpected = /** @type {(inputs: Error_UnexpectedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Unexpected error. Try again, and if it keeps happening contact support.`)
};

/**
* | output |
* | --- |
* | "Unexpected error. Try again, and if it keeps happening contact support." |
*
* @param {Error_UnexpectedInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const error_unexpected = /** @type {((inputs?: Error_UnexpectedInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_UnexpectedInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_error_unexpected(inputs)
});